export enum SupplierTypeEnum {
    AGENT = 'Agent',
    FARMER = 'Farmer',
    DEALER = 'Dealer',
}